export default {
    sender_admin: {
        heading: 'sender_admin',
        event_notification: 'sender_admin.event_notification',
        custom_fields: 'sender_admin.custom_fields',
        subscription: 'sender_admin.subscription',
        reports: 'sender_admin.reports',
        users: 'sender_admin.users',
        role: 'sender_admin.role',
        security_settings: 'sender_admin.security_settings',
        customization: 'sender_admin.customization',
        api_access: 'sender_admin.api_access',
        sub_account_management: 'sender_admin.sub_account_management',
        delegations: 'sender_admin.delegations'
    },
    groups: {
        heading: 'groups',
        group_signing_management: 'groups.group_signing_management'
    },
    templates_layouts: {
        heading: 'templates_layouts',
        share_templates: 'templates_layouts.share_templates',
        share_layouts: 'templates_layouts.share_layouts'
    },
    transaction: {
        heading: 'transaction',
        transaction: 'transaction.transaction',
        in_person: 'transaction.in_person',
        change_signer: 'transaction.change_signer',
        manage_other_users_transactions: 'transaction.manage_other_users_transactions',
        archive: 'transaction.archive'
    }
};
